// Back to top button — visibility:hidden (CSS) natively removes it from Tab order
import { isWebview } from '../../utils';
const SCROLL_UP_THRESHOLD = 400;
export const initBackToTop = () => {
    // Don't show on webview
    if (isWebview())
        return;
    const btn = document.querySelector('[data-back-to-top]');
    if (!btn)
        return;
    let lastScrollY = window.scrollY;
    let ticking = false;
    const handleScroll = () => {
        const currentScrollY = window.scrollY;
        const isScrollingUp = currentScrollY < lastScrollY;
        const isPastThreshold = currentScrollY > SCROLL_UP_THRESHOLD;
        btn.classList.toggle('back-to-top--visible', isScrollingUp && isPastThreshold);
        lastScrollY = currentScrollY;
    };
    // Scroll to top — smooth behavior handled by CSS (scroll-behavior: smooth)
    btn.addEventListener('click', () => {
        window.scrollTo({ top: 0 });
    });
    // requestAnimationFrame throttle: run handleScroll once per frame at most
    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });
};
